import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/sections/HeroSection';
import { EmpathySection } from './components/sections/EmpathySection';
import { SabotageSection } from './components/sections/SabotageSection';
import { SabotageChecklist } from './components/sections/SabotageChecklist';
import { TSAElements } from './components/sections/TSAElements';
import { ChemicalWarning } from './components/sections/ChemicalWarning';
import { ManualPresentation } from './components/sections/ManualPresentation';
import { AuthorSection } from './components/sections/AuthorSection';
import { OfferSection } from './components/sections/OfferSection';
import { Footer } from './components/sections/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-white selection:bg-brand-gold/30 selection:text-brand-lightGold" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <EmpathySection data-id="element-3" />
        <SabotageSection data-id="element-4" />
        <SabotageChecklist data-id="element-5" />
        <TSAElements data-id="element-6" />
        <ChemicalWarning data-id="element-7" />
        <ManualPresentation data-id="element-8" />
        <OfferSection data-id="element-9" />
        <AuthorSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}